import { render } from "./IslandSettings.vue?vue&type=template&id=a1bc64a8&scoped=true"
import script from "./IslandSettings.vue?vue&type=script&lang=js"
export * from "./IslandSettings.vue?vue&type=script&lang=js"

import "./IslandSettings.vue?vue&type=style&index=0&id=a1bc64a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1bc64a8"]])

export default __exports__